import InternalStorageBaseScreen from "../../shared/internalStorage/InternalStorageBaseScreen";

export const ProcessInternalStorageBase = ({ modalData }: { modalData: any }) => (
  <InternalStorageBaseScreen modalData={modalData} gate="process" variant="mapping" />
);
